export const PATIENT_STIPEND = 'Patient Stipend';
export const PATIENT_REIMBURSEMENT = 'Patient Reimbursement';
export const ALL = 'ALL';
